import axios from 'axios';
import {backendHost} from '../../config';

export const getGroupOffers = (params) => {
    return axios.get(`${backendHost}/api/partners/admin/group-offer`, {params});
};